import React from 'react';
import { FormattedMessage } from 'react-intl';
import './TroubleshootingWizardInfo.scss';
export const TroubleshootingWizardInfo = ({ items, id, }) => {
    return (<div id={id} className="troubleshooting-wizard-info" aria-live="polite" aria-atomic="true">
      {items.map((item) => (<p key={item.text} className="troubleshooting-wizard-info__item">
          {item.link ? (<FormattedMessage id={item.text} values={{
                    link: (<a href={item.link.url} target="_blank" rel="noreferrer">
                    <FormattedMessage id={item.link.text}/>
                  </a>),
                }}/>) : (<FormattedMessage id={item.text}/>)}
        </p>))}
    </div>);
};
